export default "__VITE_ASSET__CSoeQnQ___"